import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import ProjectCard from '../components/ProjectCard'; // Import the ProjectCard component
import Navbar from '../components/home/Navbar'; // Assuming you have a Navbar component
import './styles/ProjectsPage.css'; // Import your CSS file

const CompletedProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const projectsPerPage = 2; // Number of projects per page

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'projects'), where('status', '==', 1));
        const querySnapshot = await getDocs(q);
        const projectsList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // Sort projects by startDate in descending order
        projectsList.sort((a, b) => {
          const dateA = new Date(a.startDate);
          const dateB = new Date(b.startDate);
          return dateB - dateA; // Descending order
        });

        setProjects(projectsList);
      } catch (error) {
        console.error('Erreur lors de la récupération des projets : ', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Calculate the current projects to display
  const indexOfLastProject = currentPage * projectsPerPage;
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total number of pages
  const totalPages = Math.ceil(projects.length / projectsPerPage);

  return (
    <div className="projects-page">
      <Navbar />
      <div className="title-container">
        <h1 className="projects-title">Les Projets Réalisés</h1>
      </div>
      <div className="projects-content">
        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Chargement des projets...</p>
          </div>
        ) : (
          <>
            <div className="projects-list">
              {currentProjects.length > 0 ? (
                currentProjects.map(project => (
                  <ProjectCard
                    key={project.id}
                    title={project.title}
                    photo={project.photo}
                    zone={project.zone}
                    startDate={project.startDate}
                    duration={project.duration}
                    budget={project.budget}
                    bailleur={project.bailleur}
                    globalObjective={project.globalObjective}
                    specificObjectives={project.specificObjectives}
                  />
                ))
              ) : (
                <p className="no-projects">Aucun projet réalisé disponible pour le moment.</p>
              )}
            </div>
            <div className="pagination-controls">
              <button
                className="pagination-button"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Précédent
              </button>
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className="pagination-button"
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Suivant
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CompletedProjectsPage;
